import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
// import { getMediaTypeGroup } from '@motionelements/core/src/services/catalog.service.js';

export default {
  mixins: [featureFlagMixin],
  computed: {
    isProductAvailable() {
      return (product) => _.get(product, 'status', null) === 'published' || !!_.get(product, 'publishedAt', null);
    },
    redirectToNewProductPage() {
      // eslint-disable-next-line
      return (productMediaType) => {
        return this.isFeatureEnabled('product_page_2025')
          && productMediaType !== 'gif';
      };
    },
  },
  methods: {
    redirectToProductPage(event, product, linkUrl) {
      console.log('viewProduct', event);
      const isSearchRepo = process.env.VUE_APP_PROJECT_NAME && process.env.VUE_APP_PROJECT_NAME === 'frontend-search';
      const redirectUrl = linkUrl || this.linkUrl;
      if (isSearchRepo && !this.redirectToNewProductPage(product.mediaType)) {
        if (!this.isProductAvailable(product) && this.isFeatureEnabled('library_deleted_items')) {
          this.showNotAvailableModal();
        } else {
          this.$store.commit('product/setCurrentElement', product);
          // open new window: windows use ctrl key, mac use command=meta key
          // change use preventDefault to provide open tab in background function
          // https://vuejs.org/v2/guide/events.html
          // @click.exact: will only fire when no system modifiers are pressed
          // console.log('viewEvent', KeyboardEvent.key);
          if (event) event.preventDefault();
          this.$router.push({
            path: this.$link(redirectUrl).fullPath(),
            // path: this.$link(event.target.href).fullPath(),  // event.target.href not fired sometimes?
          })
            .catch(() => {})
            .finally(() => {
              if (this.isFeatureEnabled('product_pop-up_modal')) {
                if (this.$bvModal) this.$bvModal.hide('product-pop-up-modal');
              }
            });
        }
      } else {
        window.location.href = this.$link(redirectUrl).url();
      }
    },
    showNotAvailableModal() {
      this.$store.dispatch('modal/show', {
        component: () => ({
          component: import('@motionelements/core/src/components/product-card/NotAvailableProductModal.vue'),
        }),
        props: {
          product: this.product,
        },
        events: {
          onSubmit: (action) => {
            this.emitProductEvent(action);
            if (action === 'product-similar-search') {
              this.$store.dispatch('modal/hide');
            }
          },
        },
      });
    },
  },
};
